import { modify } from '../../../../../base/browser/dom.js';
import { onUnexpectedError } from '../../../../../base/common/errors.js';
import { Disposable, MutableDisposable, DisposableStore } from '../../../../../base/common/lifecycle.js';
class CellContentPart extends Disposable {
    constructor() {
        super();
        this.cellDisposables = ( new DisposableStore());
    }
    prepareRenderCell(element) { }
    renderCell(element) {
        this.currentCell = element;
        safeInvokeNoArg(() => this.didRenderCell(element));
    }
    didRenderCell(element) { }
    unrenderCell(element) {
        this.currentCell = undefined;
        this.cellDisposables.clear();
    }
    prepareLayout() { }
    updateInternalLayoutNow(element) { }
    updateState(element, e) { }
    updateForExecutionState(element, e) { }
}
class CellOverlayPart extends Disposable {
    constructor() {
        super();
        this.cellDisposables = this._register(( new DisposableStore()));
    }
    prepareRenderCell(element) { }
    renderCell(element) {
        this.currentCell = element;
        this.didRenderCell(element);
    }
    didRenderCell(element) { }
    unrenderCell(element) {
        this.currentCell = undefined;
        this.cellDisposables.clear();
    }
    updateInternalLayoutNow(element) { }
    updateState(element, e) { }
    updateForExecutionState(element, e) { }
}
function safeInvokeNoArg(func) {
    try {
        return func();
    }
    catch (e) {
        onUnexpectedError(e);
        return null;
    }
}
class CellPartsCollection extends Disposable {
    constructor(targetWindow, contentParts, overlayParts) {
        super();
        this.targetWindow = targetWindow;
        this.contentParts = contentParts;
        this.overlayParts = overlayParts;
        this._scheduledOverlayRendering = this._register(( new MutableDisposable()));
        this._scheduledOverlayUpdateState = this._register(( new MutableDisposable()));
        this._scheduledOverlayUpdateExecutionState = this._register(( new MutableDisposable()));
    }
    concatContentPart(other, targetWindow) {
        return ( new CellPartsCollection(targetWindow, this.contentParts.concat(other), this.overlayParts));
    }
    concatOverlayPart(other, targetWindow) {
        return ( new CellPartsCollection(targetWindow, this.contentParts, this.overlayParts.concat(other)));
    }
    scheduleRenderCell(element) {
        for (const part of this.contentParts) {
            safeInvokeNoArg(() => part.prepareRenderCell(element));
        }
        for (const part of this.overlayParts) {
            safeInvokeNoArg(() => part.prepareRenderCell(element));
        }
        for (const part of this.contentParts) {
            safeInvokeNoArg(() => part.renderCell(element));
        }
        this._scheduledOverlayRendering.value = modify(this.targetWindow, () => {
            for (const part of this.overlayParts) {
                safeInvokeNoArg(() => part.renderCell(element));
            }
        });
    }
    unrenderCell(element) {
        for (const part of this.contentParts) {
            safeInvokeNoArg(() => part.unrenderCell(element));
        }
        this._scheduledOverlayRendering.value = undefined;
        this._scheduledOverlayUpdateState.value = undefined;
        this._scheduledOverlayUpdateExecutionState.value = undefined;
        for (const part of this.overlayParts) {
            safeInvokeNoArg(() => part.unrenderCell(element));
        }
    }
    updateInternalLayoutNow(viewCell) {
        for (const part of this.contentParts) {
            safeInvokeNoArg(() => part.updateInternalLayoutNow(viewCell));
        }
        for (const part of this.overlayParts) {
            safeInvokeNoArg(() => part.updateInternalLayoutNow(viewCell));
        }
    }
    prepareLayout() {
        for (const part of this.contentParts) {
            safeInvokeNoArg(() => part.prepareLayout());
        }
    }
    updateState(viewCell, e) {
        for (const part of this.contentParts) {
            safeInvokeNoArg(() => part.updateState(viewCell, e));
        }
        this._scheduledOverlayUpdateState.value = modify(this.targetWindow, () => {
            for (const part of this.overlayParts) {
                safeInvokeNoArg(() => part.updateState(viewCell, e));
            }
        });
    }
    updateForExecutionState(viewCell, e) {
        for (const part of this.contentParts) {
            safeInvokeNoArg(() => part.updateForExecutionState(viewCell, e));
        }
        this._scheduledOverlayUpdateExecutionState.value = modify(this.targetWindow, () => {
            for (const part of this.overlayParts) {
                safeInvokeNoArg(() => part.updateForExecutionState(viewCell, e));
            }
        });
    }
}
export { CellContentPart, CellOverlayPart, CellPartsCollection };
